import { Subject } from 'rxjs';

import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

import { platform } from '../../../../platform/platform';
import { InspectionImage } from '../../../_objects/inspection-image';
import { UtilsService } from '../../../_services/_utils.service';
import { InspectionImageService } from '../../../_services/http-api/inspection-image.service';
import { NetworkStatusService } from '../../../_services/network-status.service';
import { SpinnerService } from '../../../_services/spinner.service';
import { BROWSER_TYPE, PLATFORM, USE_IMAGE_TYPE } from '../../../app.constants';
import { BlobService } from '../../../_services/blob.service';
import { ImageMetadata } from "../../../_objects/image-metadata";
import { ExifReaderService } from "../../../_services/exif-reader.service";

@Component({
    selector: 'app-image-property-edit',
    templateUrl: './image-property-edit.component.html',
    styleUrls: ['./image-property-edit.component.scss'],
    standalone: false
})
export class ImagePropertyEditComponent implements OnChanges, OnDestroy {

  @Input() inspectionImage: InspectionImage;
  @Input() index: number;
  @Input() listCount: number;
  @Input() isPreviewReport: boolean;

  @Output() applyMove = new EventEmitter<boolean>();

  imgSrcBase64: string;
  dspImgWidth: string;
  dspImgHeight: string;
  imgMarginRight: string;
  imageListIndex: number;
  isBackImage = false;
  isForwardImage = false;
  isLoadedImg = false;
  imageMetadata: ImageMetadata;

  onDestroy$ = new Subject();

  constructor(
    private inspectionImageService: InspectionImageService,
    private oscSpinnerService: SpinnerService,
    private utilsService: UtilsService,
    private blobService: BlobService,
    private networkStatusService: NetworkStatusService,
    private exifReaderService: ExifReaderService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.inspectionImage) {
      this.oscSpinnerService.show(true);
      this.loadImage();
      this.setArrowButton();
      this.isLoadedImg = true;
    }
  }

  ngOnDestroy() {
    this.onDestroy$.next(undefined);
    this.onDestroy$.unsubscribe();
  }

  /** オンラインかどうか。(ApiService.service の判定方法を参考にした。) */
  public get isOnline(): boolean {
    return this.networkStatusService.isOnline;
  }

  async loadImage(): Promise<void> {
    try {

      const imageSrc = await this.inspectionImageService.getImageBinaryUrl(
        this.inspectionImage.inspectionId, this.inspectionImage.id, USE_IMAGE_TYPE.ORIGINAL);

      this.imageMetadata =  await this.exifReaderService.getImageMetadata(this.inspectionImage);
      const base64 = await this.blobService.getBase64ImageFromUrl(imageSrc);

      this.setupImageOnCanvas(base64);
    } catch (err) {
      this.oscSpinnerService.hide(true);
      console.error('Failed to load image:', err);
    }
  }

  private setupImageOnCanvas(base64: string): void {
    const image = new Image();
    this.imgSrcBase64 = base64;
    image.src = base64;
    image.onload = () => this.setupImage(image);
  }
  setupImage(image: HTMLImageElement): void {
    const mainContent = document.getElementsByClassName('modal__content')[0];
    const dataArea = document.getElementById('property-area');
    const maxImageSize = Math.max(image.width, image.height);
    const minElementSize = Math.min(mainContent.clientWidth - dataArea.clientWidth, mainContent.clientHeight - 158);
    const scale = minElementSize / maxImageSize;

    this.dspImgWidth = (image.width * scale).toString() + 'px';
    this.dspImgHeight = (image.height * scale).toString() + 'px';
    this.imgMarginRight = image.width * scale >= 500 ? '150px' : '50px';

    this.oscSpinnerService.hide(true);
  }

  setArrowButton() {
    this.isBackImage = this.index > 0;
    this.isForwardImage = this.index < this.listCount - 1;
    this.imageListIndex = this.index;
  }

  backSwipe() {
    if (this.utilsService.getBrowserName() === BROWSER_TYPE.SAFARI) {
      this.oscSpinnerService.show(true);
      this.applyMove.emit(true);
    }
  }

  forwardSwipe() {
    if (this.utilsService.getBrowserName() === BROWSER_TYPE.SAFARI) {
      this.oscSpinnerService.show(true);
      this.applyMove.emit(false);
    }
  }

  changeIndex(isBack: boolean): void {
    this.applyMove.emit(isBack);
  }

  get properties() {
    return [
      { value: this.inspectionImage.datetime, key: 'imagePropertyEdit.datetimePlaceholder' },
      { value: this.inspectionImage.scopeModel, key:  'imagePropertyEdit.videoscopeModelPlaceholder' },
      { value: this.inspectionImage.metadata.adapterName, key: 'imagePropertyEdit.tipAdaptorModelPlaceholder' },
      { value: this.inspectionImage.metadata.setNumber, key: 'imagePropertyEdit.tipAdaptorSerialNumberPlaceholder' }
    ];
  }
}
